import PropTypes from 'prop-types'
import React from 'react'
import ReactModal from 'react-modal'
import Button from '../Button/Button'
import Spinner from '../Spinner/Spinner'
import cn from 'classnames'
import { observer } from 'mobx-react'
import { observable, action, computed, makeObservable } from 'mobx'

const color = PropTypes.color

// close button positions
const LEFT = 'Left'
const CENTER = 'Center'
const RIGHT = 'Right'
const TOP = 'Top'
const BOTTOM = 'Bottom'

const Modal = observer(class Modal extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    isLoad: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    headerText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    bodyText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    onAction: PropTypes.func,
    canAction: PropTypes.bool,
    actionText: PropTypes.string,
    actionType: PropTypes.string,
    hideSpinner: PropTypes.bool,
    hideFooter: PropTypes.bool,
    size: PropTypes.string,
    displayHeader: PropTypes.bool,

    closeButton: PropTypes.shape({
      isVisible: PropTypes.bool,
      backgroundColor: color,
      color: color,
      text: PropTypes.string,
      width: PropTypes.string,
      height: PropTypes.string,
      horizontal: PropTypes.oneOf([
        'Left',
        'Center',
        'Right'
      ]),
      vertical: PropTypes.oneOf([
        'Top',
        'Bottom'
      ])
    }),
    showCloseX: PropTypes.bool
  }

  static defaultProps = {
    closeButton: {
      isVisible: false,
      showCloseX: true,
      vertical: 'Bottom',
      horizontal: 'Center'
    }
  }

  isOpen = this.props.isOpen
  notifyClosed = false

  constructor (props) {
    super(props)

    makeObservable(this, {
      isOpen: observable,
      notifyClosed: observable,
      transitions: computed,
      onClose: action,
      onRequestClose: action,
      onAfterClose: action,
      componentDidUpdate: action
    })
  }

  get transitions () {
    const { duration = 300, enter = 'zoomIn', exit = 'zoomOut' } = this.props.transition || this.props.contentStyle.transition || {}
    return { duration, enter, exit }
  }

  onClose = (e) => {
    this.isOpen = false
    this.notifyClosed = true
    if (this.props.stopPropagationOnClose) e.stopPropagation()
    this.onRequestClose()
  }

  preventClick = (e) => {
    return false
  }

  onRequestClose = () => {
    this.isOpen = false
    this.notifyClosed = true
  }

  onAfterClose = () => {
    if (this.notifyClosed && this.props.onCancel) {
      this.notifyClosed = false
      this.props.onCancel()
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.isOpen = this.props.isOpen
    }
  }

  //
  getCloseButton = (closeButtonProps, isTop) => {
    if (!closeButtonProps.isVisible) {
      return
    }

    const defaultBtn = <Button
      style={{
        backgroundColor: closeButtonProps.backgroundColor,
        color: closeButtonProps.color,
        width: closeButtonProps.width,
        height: closeButtonProps.height,
        display: 'inline-block'
      }}
      type='secondary'
      onClick={this.onClose}
      label={this.props.cancelLabel || closeButtonProps.text || 'Close'} />
    const style = {}
    switch (closeButtonProps.horizontal) {
      case CENTER:
        style.textAlign = 'center'
        break
      case LEFT:
        style.textAlign = 'left'
        break
      case RIGHT:
        style.textAlign = 'right'
    }

    const container = <div style={style}> {defaultBtn}</div>
    return container
  }

  getXButton = (showCloseX, color) => {
    if (showCloseX) {
      return <div style={{ textAlign: 'right' }}><Button
        onClick={this.onClose}
        icon='close'
        iconSize='2x'
        iconColor={color}
        iconPlacement='top'
        label=''
        type='default'
        style={{ width: '40px', height: '30px', display: 'inline-block' }} /></div>
    }
  }

  render () {
    const {
      size,
      isLoad,
      headerText,
      displayHeader,
      bodyText,
      onAction,
      canAction,
      actionText,
      hideSpinner,
      hideFooter,
      actionType,
      closeButton,
      backgroundColor,
      closeXColor,
      showCloseX
    } = this.props
    const style = {
      overlay: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        background: 'rgba(126,140,153,.8)',
        zIndex: 100000
      },
      content: {
        boxSizing: 'border-box',
        position: 'relative',
        padding: '1rem',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        margin: '0 auto',
        width: size === 'large' ? '90%' : '50%',
        maxWidth: size === 'large' ? 'none' : '40rem',
        minWidth: '20rem',
        display: 'flex',
        // flexDirection: 'column',
        background: backgroundColor || 'white',
        border: 'none',
        overflow: 'scroll',
        zIndex: 10
      }
    }
    const overlayStyle = this.props.overlayStyle || {}
    const contentStyle = this.props.contentStyle || {}
    const transitions = this.transitions
    return (
      <div className='psmodal' onClick={this.preventClick}>
        <ReactModal
          isOpen={this.isOpen}
          size={size}
          style={{
            ...style,
            content: { ...style.content, ...contentStyle },
            overlay: { ...style.overlay, ...overlayStyle }
          }}
          ariaHideApp={false}
          shouldCloseOnEsc={this.props.shouldCloseOnEsc}
          parentSelector={this.props.parentSelector}
          closeTimeoutMS={transitions.duration}
          onAfterClose={this.onAfterClose}
          onRequestClose={this.onRequestClose}>
          <div className='wrap-all'>
            {this.getXButton(showCloseX, closeXColor)}
            {closeButton.vertical === TOP ? this.getCloseButton(closeButton) : null}
            {headerText && displayHeader ? (
              <div className={cn('header')} style={{ backgroundColor: backgroundColor }}>
                <h2>
                  {headerText}
                </h2>
              </div>
            ) : null}
            <div className={cn('content', hideFooter && 'without-footer')} style={{ margin: '1rem 0' }}>
              {bodyText}
            </div>
            {hideFooter
              ? null
              : <div className='footer'>
                {onAction ? (
                  <Button type={actionType || 'secondary'} onClick={onAction} label={actionText} disabled={canAction} />
                ) : null}
                {hideSpinner ? null : <Spinner isVisible={isLoad} type='absolute' />}
              </div>}
            {closeButton.vertical === BOTTOM ? this.getCloseButton(closeButton) : null}
          </div>
        </ReactModal>
        <style jsx>{`
          :global(.ReactModal__Content--after-open) {
            animation-duration: ${transitions.duration}ms;
            animation-fill-mode: both;
            animation-name: ${transitions.enter};
          }
          :global(.ReactModal__Content--before-close) {
            animation-duration: ${transitions.duration}ms;
            animation-fill-mode: both;
            animation-name: ${transitions.exit};
          }

          .wrap-all {
            position: relative;
            border-radius: var(--borderRadius);
            overflow: hidden;
            width: 100%;
            height: 95%;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
          }
          .header, .content, .footer {
            background: white;
            padding: 0.5rem;
          }
          .header {
            flex-shrink: 0;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            flex-shrink: 0;
            border-top-left-radius: var(--borderRadius);
            border-top-right-radius: var(--borderRadius);
            border-bottom: 1px solid var(--paleGrey);

            h2 {
              flex-grow: 1;
              margin: 0;
            }
          }
          .content {
            flex-grow: 1;
            min-height: 2em;
            overflow: hidden;
            overflow-y: auto;
            &.without-footer {
              border-bottom-left-radius: var(--borderRadius);
              border-bottom-right-radius: var(--borderRadius);
            }
          }
          .footer {
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;
            flex-direction: row;
            flex-shrink: 0;
            border-top: 1px solid var(--paleGrey);
            border-bottom-left-radius: var(--borderRadius);
            border-bottom-right-radius: var(--borderRadius);
            background-color: ${backgroundColor};
            .psmodal :global(button) {
              margin-left: 0.5rem;
            }
          }

          `}</style>
      </div>
    )
  }
})

export default Modal
